export default {
  root: {
    padding: '10px'
  }
};
